<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="sz"> </span></p>
<p class="p4"><span class="sz">For Poul and Karen<span class="Apple-converted-space"> </span></span></p>
<p class="p4"><span class="sz">with much appreciation<span class="Apple-converted-space"> </span></span></p>
<p class="p4"><span class="sz">and love.</span></p>
<p class="p5"><span class="sz"><b></b> </span></p>
<p class="p2"><span class="sz"><b></b> </span></p>
<p class="p2"><span class="sz"><b></b> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?04002e4c